import React from 'react'
import { FaUserEdit } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'
import './permissions-control.less'

type CreatorControlProps = {
  viewOnly?: boolean | undefined
}

const CreatorControl = ({ viewOnly }: CreatorControlProps) => {
  return (
    <div className={cn('control', 'permissions-control', { selected: true, viewOnly })} data-graph-type="control">
      <a className={cn('icon')} title="Creator">
        <FaUserEdit aria-hidden />
        <span className="sr-only">Owner</span>
      </a>
    </div>
  )
}

export default CreatorControl
